import React from "react";
import { portraits } from "../../assets/images/races";
import GovernorateInfoLink from "./GovernorateInfoLink";

interface IProps {
  id: number;
  name: string;
  race: string;
  commander: boolean;
  emperor: boolean;
}

const GovernoratePivotColumn = ({
  id,
  name,
  race,
  commander,
  emperor
}: IProps) => (
  <td className="no-padding-left text-left" style={{ width: "150px" }}>
    <span>
      <img width={37} height={37} src={portraits[race]} alt={"Race portrait"}/>
    </span>
    <span style={{ display: "inline-table", verticalAlign: "super" }}>
      <GovernorateInfoLink
        govId={id}
        name={name}
        raceName={race}
      /><br/>
      {commander && <i className={`icon icon-vojevudce icon-xs ${race}`}/>}
      {emperor && <i className={`icon icon-imperator icon-xs ${race}`}/>}
    </span>
  </td>
)

export default GovernoratePivotColumn;
